/*
 * Copyright (c) 2019 brightlamp
 */

const Account = () => import(/* webpackChunkName: "account" */ '@/views/account');
const ExportTestResults = () => import(/* webpackChunkName: "account" */ '@/views/account/mrn-results-export');
const ExportTestResultsList = () => import(/* webpackChunkName: "account" */ '@/views/account/mrn-results-export-list');
const Home = () => import(/* webpackChunkName: "account" */ '@/views/account/home');
const MessageCenter = () => import(/* webpackChunkName: "account" */ '@/views/account/message-center-dashboard');
const Settings = () => import(/* webpackChunkName: "account" */ '@/views/account/settings');
const TelehealthDashboard = () => import(/* webpackChunkName: "account" */ '@/views/account/telehealth-dashboard');
const TestResults = () => import(/* webpackChunkName: "account" */ '@/views/account/mrn-results');

export default
[
    {
        path: '/account',
        component: Account,
        meta:
        {
            requiresAuth: true
        },
        children:
        [
            {
                path: '',
                name: 'Home',
                component: Home,
                meta:
                {
                    title: 'Home'
                }
            },
            {
                path: 'patient-ids',
                name: 'Patient ID Test Results',
                component: TestResults,
                meta:
                {
                    title: 'Trending & Exports'
                }
            },
            {
                path: 'patient-ids/:testToken',
                name: 'Patient ID Test Results For Link',
                component: TestResults,
                meta:
                {
                    title: 'Trending & Exports'
                }
            },
            {
                path: 'export-patient-ids/:guid',
                name: 'Export Patient ID Test Results',
                component: ExportTestResults,
                meta:
                {
                    title: 'Export Patient ID Test Results'
                }
            },
            {
                path: 'export-patent-ids-list',
                name: 'Export Patient ID Test Results List',
                component: ExportTestResultsList,
                meta:
                {
                    title: 'Download Exported Tests'
                }
            },
            {
                path: 'message-center',
                name: 'Message Center',
                component: MessageCenter,
                meta:
                {
                    title: 'Message Center'
                }
            },
            {
                path: 'telehealth-dashboard',
                name: 'Telehealth Dashboard',
                component: TelehealthDashboard,
                meta:
                {
                    title: 'Telehealth Dashboard'
                }
            },
            {
                path: 'settings',
                name: 'Settings',
                component: Settings,
                meta:
                {
                    title: 'Settings'
                }
            }
        ]
    }
]
